import React, { useEffect, useState } from 'react';

import { useTheme } from '../../App';

import { NavLink } from 'react-router-dom';

import { motion } from 'framer-motion';

import BackButton from '../../components/common/BackButton/BackButton';

import { getSettings } from '../../services/settingsCache';

import { apiClient } from '../../services/apiClient';

import './About.css';



const aboutHeroBgDefault = `${process.env.PUBLIC_URL}/assets/images/Container.png`;

export default function AboutUs() {

  const { isNightMode } = useTheme();

  const [settings, setSettings] = useState(null);
  const [aboutContent, setAboutContent] = useState(null);
  const [showEnquiryModal, setShowEnquiryModal] = useState(false);

  const [enquiryData, setEnquiryData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [enquiryStatus, setEnquiryStatus] = useState('');



  useEffect(() => {

    let cancelled = false;



    const loadContent = async () => {

      try {

        // Load about page content from content management API
        const aboutData = await apiClient.get('/content/about');
        if (!cancelled && aboutData) {
          setAboutContent(aboutData);
        }

        // Also load general settings
        const settingsData = await getSettings();
        if (!cancelled && settingsData) {
          setSettings(settingsData);
        }

      } catch (err) {

        console.error('Failed to load about content', err);

      }

    };



    loadContent();



    return () => {

      cancelled = true;

    };

  }, []);

  const handleSubmitEnquiry = async () => {
    // Validation
    if (!enquiryData.name.trim() || !enquiryData.phone.trim() || !enquiryData.message.trim()) {
      setEnquiryStatus('Please fill in all required fields (Name, Phone, and Message)');
      setTimeout(() => setEnquiryStatus(''), 3000);
      return;
    }

    // Store data before clearing
    const originalEnquiryData = { ...enquiryData };

    // INSTANT SUCCESS - Show success immediately
    setEnquiryData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
    setEnquiryStatus('Enquiry submitted successfully! We will contact you soon.');

    // Close modal after 1 second and clear status
    setTimeout(() => {
      setShowEnquiryModal(false);
      setEnquiryStatus('');
    }, 1000);

    // Process in background WITHOUT blocking UI
    (async () => {
      try {
        await apiClient.post('/contact', {
          name: originalEnquiryData.name,
          email: originalEnquiryData.email,
          phone: originalEnquiryData.phone,
          subject: 'Enquiry from About Page',
          message: originalEnquiryData.message
        });
        // Success - no action needed as we already showed success
      } catch (error) {
        console.error('Background submission failed:', error);
        // If background fails, show error and restore form
        setEnquiryData(originalEnquiryData);
        setEnquiryStatus('Failed to submit enquiry. Please try again or contact us directly.');
        setTimeout(() => setEnquiryStatus(''), 5000);
      }
    })();
  };

  const aboutHeroBg = (aboutContent && aboutContent.heroImageUrl) || (settings && settings.aboutHeroImageUrl) || aboutHeroBgDefault;

  const heroBadge = (aboutContent && aboutContent.heroBadge) || (settings && settings.aboutHeroBadge) || 'About';

  const heroTitle = (aboutContent && aboutContent.heroTitle) || (settings && settings.aboutHeroTitle) || 'Building Trust Since 1998';

  const heroSubtitle = (aboutContent && aboutContent.heroSubtitle) || (settings && settings.aboutHeroSubtitle) || 'For over 25 years, Tiwari Syndicate has been the trusted name in premium construction materials, serving thousands of satisfied customers across India.';

  const storyTitle = (aboutContent && aboutContent.storyTitle) || (settings && settings.aboutStoryTitle) || 'From Humble Beginnings to Industry Leadership';

  const storyParagraph1 = (aboutContent && aboutContent.storyParagraph1) || (settings && settings.aboutStoryParagraph1) || 'Tiwari Syndicate was founded in 1998 with a mission to deliver the highest quality materials to builders and homeowners across India. What started as a small plywood supplier is now a trusted name in construction materials.';

  const storyParagraph2 = (aboutContent && aboutContent.storyParagraph2) || (settings && settings.aboutStoryParagraph2) || 'We serve thousands of customers nationwide, offering an extensive range of premium plywood, laminates, sanitary ware, and building products.';

  const storyParagraph3 = (aboutContent && aboutContent.storyParagraph3) || (settings && settings.aboutStoryParagraph3) || 'Our team of experts ensures that you make the right choice for your construction needs.';



  const aboutStats = [
    { value: '25+', label: 'Years of Excellence' },
    { value: '500+', label: 'Happy Customers' },
    { value: '1000+', label: 'Projects Completed' },
    { value: '15+', label: 'Expert Team Members' },
  ];

  const missionTitle = (aboutContent && aboutContent.missionTitle) || (settings && settings.aboutMissionTitle) || 'Our Mission';

  const missionBody = (aboutContent && aboutContent.missionBody) || (settings && settings.aboutMissionBody) || 'To be the most trusted provider of premium construction materials in India by delivering exceptional quality products and unmatched customer service.';

  const visionTitle = (aboutContent && aboutContent.visionTitle) || (settings && settings.aboutVisionTitle) || 'Our Vision';

  const visionBody = (aboutContent && aboutContent.visionBody) || (settings && settings.aboutVisionBody) || 'To revolutionize the construction materials industry through innovation, sustainability, and customer-centric solutions.';

  const coreValues = (aboutContent && Array.isArray(aboutContent.coreValues) && aboutContent.coreValues.length) ? aboutContent.coreValues : (settings && Array.isArray(settings.aboutCoreValues) && settings.aboutCoreValues.length ? settings.aboutCoreValues : [
    {
      icon: '??',
      title: 'Quality First',
      desc: 'We never compromise on quality. Every product meets international standards.',
    },
    {
      icon: '??',
      title: 'Customer Satisfaction',
      desc: 'Your satisfaction is our top priority. We go the extra mile for you.',
    },
    {
      icon: '??',
      title: 'Trust & Integrity',
      desc: 'Built on honest relationships and transparent business practices.',
    },
    {
      icon: '??',
      title: 'Innovation',
      desc: 'Constantly evolving with the latest materials and technologies.',
    },
  ]);

  const timelineItems = (aboutContent && Array.isArray(aboutContent.timelineItems) && aboutContent.timelineItems.length) ? aboutContent.timelineItems : (settings && Array.isArray(settings.aboutTimelineItems) && settings.aboutTimelineItems.length ? settings.aboutTimelineItems : [
    {
      year: '1999',
      title: 'Company Founded',

      desc: 'Started as a small plywood supplier',

    },

    {

      year: '2005',

      title: 'Expansion',

      desc: 'Expanded to decorative laminates and veneers',

    },

    {

      year: '2018',

      title: 'Pan-India Presence',

      desc: 'Established distribution network across India',

    },

    {

      year: '2023',

      title: 'Digital Transformation',

      desc: 'Launched online platform for seamless ordering',

    },

    {

      year: '2025',

      title: 'Industry Leader',

      desc: 'Recognized as interiors construction material supplier',

    },

  ]);

  const teamMembersRaw = [

        {

          imageUrl:

            'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y&s=800',

          name: 'Birendra Kumar',

          role: 'Founder &  Managing Director',

        },

        {

          imageUrl:

            'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y&s=800',

          name: 'Sachin Tiwari',

          role: 'CEO & Director',

        },

        // {

        //   imageUrl:

        //     'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?auto=format&fit=crop&w=800&q=80',

        //   name: 'Amit Kumar',

        //   role: 'Sales Head',

        // },

        // {

        //   imageUrl:

        //     'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=800&q=80',

        //   name: 'Sneha Patel',

        //   role: 'Customer Relations',

        // },

      ];



  const teamMembers = teamMembersRaw.map((member) => ({

    img: member.imageUrl || member.img,

    name: member.name,

    role: member.role,

  }));



  const whyTitle =

    (settings && settings.aboutWhyTitle) || 'Why Choose Tiwari Syndicate?';

  const whySubtitle =

    (settings && settings.aboutWhySubtitle) ||

    'Our values, experience, and nationwide presence make us the trusted choice for builders across India.';

  const whyReasons =

    settings && Array.isArray(settings.aboutWhyReasons) && settings.aboutWhyReasons.length

      ? settings.aboutWhyReasons

      : [

        'ISO 9001:2008 certified quality assurance',

        'Direct partnerships with leading manufacturers',

        'Competitive pricing with no hidden costs',

        'Expert technical consultation and support',

        'Timely delivery across pan-India network',

        'Extensive product range under one roof',

        'Flexible payment options available',

        'After-sales service and warranty support',

      ];



  const whyStatsRaw =

    settings && Array.isArray(settings.aboutWhyStats) && settings.aboutWhyStats.length

      ? settings.aboutWhyStats

      : [

        { value: '15+', label: 'Distribution Centers' },

        { value: '100+', label: 'Cities Served' },

        { value: '50+', label: 'Team Members' },

        { value: '10+', label: 'Industry Awards' },

      ];



  const defaultWhyStatsMeta = [

    { bg: '#A8D08D', icon: require('../../assets/images/Icon.png') },

    { bg: '#1E252F', icon: require('../../assets/images/Icon (1).png') },

    { bg: '#1E252F', icon: require('../../assets/images/Icon (2).png') },

    { bg: '#A8D08D', icon: require('../../assets/images/Icon (3).png') },

  ];



  const whyStats = whyStatsRaw.map((stat, idx) => {

    const meta = defaultWhyStatsMeta[idx % defaultWhyStatsMeta.length];

    return { ...stat, ...meta };

  });



  const aboutCtaTitle =

    (settings && settings.aboutCtaTitle) || 'Ready to Work With Us?';

  const aboutCtaSubtitle =

    (settings && settings.aboutCtaSubtitle) ||

    'Join thousands of satisfied customers who trust Tiwari Syndicate for their construction material needs.';

  const aboutCtaPrimaryLabel =

    (settings && settings.aboutCtaPrimaryLabel) || 'Browse Products';

  const aboutCtaPrimaryHref =

    (settings && settings.aboutCtaPrimaryHref) || '/products';

  const aboutCtaSecondaryLabel =

    (settings && settings.aboutCtaSecondaryLabel) || 'Contact Us';

  const aboutCtaSecondaryHref =

    (settings && settings.aboutCtaSecondaryHref) || '/contact';



  return (

    <main

      className="about-page"

      style={{

        background: "#ffffff",

        fontFamily: "Arial, sans-serif",

      }}

    >

      {/* HERO SECTION */}

      <section

        className="about-hero"

        style={{

          backgroundImage: `url(${aboutHeroBg})`,

        }}

      >

        <div aria-hidden="true" className="about-hero__overlay" />

        <motion.div

          className="about-hero__inner"

          initial={{ opacity: 0, y: 30 }}

          animate={{ opacity: 1, y: 0 }}

          transition={{ duration: 0.6, ease: "easeOut" }}

        >

          <motion.span

            className="about-hero__pill"

            style={{

              marginBottom: '14px'

            }}

            initial={{ opacity: 0, scale: 0.8 }}

            animate={{ opacity: 1, scale: 1 }}

            transition={{ duration: 0.4, delay: 0.2 }}

          >

            {heroBadge}

          </motion.span>



          <motion.h1

            className="about-hero__title"

            initial={{ opacity: 0, x: -30 }}

            animate={{ opacity: 1, x: 0 }}

            transition={{ duration: 0.6, delay: 0.3 }}

          >

            {heroTitle}

          </motion.h1>



          <motion.p

            className="about-hero__subtitle"

            initial={{ opacity: 0, y: 20 }}

            animate={{ opacity: 0.9, y: 0 }}

            transition={{ duration: 0.6, delay: 0.4 }}

          >

            {heroSubtitle}

          </motion.p>

        </motion.div>

      </section>



      {/* BREADCRUMB */}

      <div

        style={{

          background: isNightMode ? "#1e293b" : "#F8F9FA",

          padding: "15px 40px",

          fontSize: "0.95rem",

          color: isNightMode ? "#cbd5e1" : "#6c757d",

          borderBottom: isNightMode ? "1px solid #334155" : "1px solid #e5e5e5",

          display: 'flex',

          alignItems: 'center',

          gap: 10,

          flexWrap: 'wrap',

        }}

      >

        <BackButton fallbackTo="/" />



        <div>

          <NavLink

            to="/"

            style={{

              textDecoration: 'none',

              color: isNightMode ? '#cbd5e1' : '#6c757d',

              fontWeight: 500,

              marginRight: 4,

            }}

          >

            HOME

          </NavLink>

          <span aria-hidden>›</span>{' '}

          <span style={{ color: isNightMode ? '#fff' : '#000', marginLeft: 4 }}>About</span>

        </div>

      </div>



      {/* STATS SECTION */}

      <section

        className="about-stats"

        style={{

          background: "linear-gradient(135deg, #4A6640 0%, #5D7F4E 100%)",

          color: "white",

          padding: "60px 20px",

          textAlign: "center",

        }}

      >

        <div className="about-stats__inner">

          <div className="about-stats__grid">

            {aboutStats.map((item, index) => (

              <motion.div

                key={index}

                initial={{ opacity: 0, y: 30 }}

                whileInView={{ opacity: 1, y: 0 }}

                viewport={{ once: true, margin: "-100px" }}

                transition={{ duration: 0.5, delay: index * 0.1 }}

                whileHover={{ scale: 1.05, y: -5 }}

              >

                <h2 style={{ fontSize: "2.4rem", marginBottom: "10px" }}>

                  {item.value}

                </h2>

                <p style={{ opacity: 0.9 }}>{item.label}</p>

              </motion.div>

            ))}

          </div>

        </div>

      </section>



      {/* STORY SECTION */}

      <motion.section

        style={{

          padding: "80px 20px",

          maxWidth: "1200px",

          margin: "0 auto",

          display: "flex",

          alignItems: "center",

          gap: "60px",

          flexWrap: "wrap",

        }}

        initial={{ opacity: 0 }}

        whileInView={{ opacity: 1 }}

        viewport={{ once: true, margin: "-100px" }}

        transition={{ duration: 0.6 }}

      >

        {/* Left Column - Text Content */}

        <motion.div

          style={{ flex: "1", minWidth: "300px" }}

          initial={{ opacity: 0, x: -50 }}

          whileInView={{ opacity: 1, x: 0 }}

          viewport={{ once: true }}

          transition={{ duration: 0.6 }}

        >

          <span

            style={{

              display: 'inline-block',

              padding: '6px 12px',

              borderRadius: '9999px',

              background: '#A7E08D',

              border: '0',

              color: '#000',

              fontFamily: 'Arial, sans-serif',

              fontSize: '12px',

              fontStyle: 'normal',

              fontWeight: 400,

              lineHeight: '16px',

              textTransform: 'none',

              letterSpacing: '0',

              marginBottom: '14px'

            }}

          >

            Our Story

          </span>



          <h2

            style={{

              fontSize: "1.8rem",

              fontWeight: "700",

              margin: "0 0 15px 0",

              lineHeight: "1.3",

              color: isNightMode ? "#f1f5f9" : "#1a1a1a"

            }}

          >

            {storyTitle}

          </h2>



          <div style={{ marginBottom: "20px" }}>

            <p style={{

              color: isNightMode ? "#cbd5e1" : "#666",

              lineHeight: "1.6",

              margin: "0 0 12px 0",

              fontSize: "0.95rem"

            }}>

              {storyParagraph1}

            </p>

            <p style={{

              color: isNightMode ? "#e2e8f0" : "#4a4a4a",

              lineHeight: "1.7",

              margin: "0 0 15px 0"

            }}>

              {storyParagraph2}

            </p>

            <p style={{

              color: isNightMode ? "#e2e8f0" : "#4a4a4a",

              lineHeight: "1.7",

              margin: "0 0 25px 0"

            }}>

              {storyParagraph3}

            </p>

          </div>



          <button
            onClick={() => setShowEnquiryModal(true)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '42px',
              padding: '0 24px',
              borderRadius: '6px',
              border: 'none',
              background: '#22c55e',
              color: '#ffffff',
              fontFamily: 'inherit',
              fontSize: '16px',
              fontWeight: '700',
              letterSpacing: '0.5px',
              marginBottom: '20px',
              cursor: 'pointer',
              transition: 'background 0.2s ease'
            }}
            onMouseOver={(e) => e.currentTarget.style.background = "#16a34a"}
            onMouseOut={(e) => e.currentTarget.style.background = "#22c55e"}
          >
            Get in Touch
          </button>

        </motion.div>



        {/* Right Column - Image */}

        <motion.div

          className="about-story__image"

          style={{

            flex: "1",

            minWidth: "300px",

            position: "relative",

            borderRadius: "10px",

            overflow: "hidden",

            boxShadow: isNightMode ? "0 15px 30px rgba(0,0,0,0.5)" : "0 15px 30px rgba(0,0,0,0.1)"

          }}

          initial={{ opacity: 0, x: 50 }}

          whileInView={{ opacity: 1, x: 0 }}

          viewport={{ once: true }}

          transition={{ duration: 0.6 }}

          whileHover={{ scale: 1.02 }}

        >

          <img

            src={`${process.env.PUBLIC_URL}/assets/images/imagw2.png`}

            alt="Team meeting"

          />

        </motion.div>

      </motion.section>



      {/* MISSION & VISION */}

      <section

        className="about-mission"

        style={{

          maxWidth: "1100px",

          margin: "0 auto",

          padding: "40px 20px",

        }}

      >

        <div className="about-mission__grid">

          {/* Mission Card */}

          <motion.div

            style={{

              padding: "30px",

              borderRadius: "12px",

              background: isNightMode ? "#1e293b" : "#fff",

              boxShadow: isNightMode ? "0 3px 10px rgba(0,0,0,0.3)" : "0 3px 10px rgba(0,0,0,0.08)",

            }}

            initial={{ opacity: 0, y: 30 }}

            whileInView={{ opacity: 1, y: 0 }}

            viewport={{ once: true }}

            transition={{ duration: 0.5 }}

            whileHover={{ y: -5, scale: 1.02 }}

          >

            <div

              style={{

                background: "#E6F4EA",

                width: "50px",

                height: "50px",

                borderRadius: "50%",

                display: "flex",

                alignItems: "center",

                justifyContent: "center",

                marginBottom: "20px",

                fontSize: "1.6rem",

              }}

            >

              🔄

            </div>



            <h3 style={{ marginBottom: "12px", color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>{missionTitle}</h3>

            <p style={{ lineHeight: 1.6, color: isNightMode ? "#cbd5e1" : "#555" }}>

              {missionBody}

            </p>

          </motion.div>



          {/* Vision Card */}

          <motion.div

            style={{

              padding: "30px",

              borderRadius: "12px",

              background: isNightMode ? "#1e293b" : "#fff",

              boxShadow: isNightMode ? "0 3px 10px rgba(0,0,0,0.3)" : "0 3px 10px rgba(0,0,0,0.08)",

            }}

            initial={{ opacity: 0, y: 30 }}

            whileInView={{ opacity: 1, y: 0 }}

            viewport={{ once: true }}

            transition={{ duration: 0.5, delay: 0.1 }}

            whileHover={{ y: -5, scale: 1.02 }}

          >

            <div

              style={{

                background: "#E6F4EA",

                width: "50px",

                height: "50px",

                borderRadius: "50%",

                display: "flex",

                alignItems: "center",

                justifyContent: "center",

                marginBottom: "20px",

                fontSize: "1.6rem",

              }}

            >

              👁️

            </div>



            <h3 style={{ marginBottom: "12px", color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>{visionTitle}</h3>

            <p style={{ lineHeight: 1.6, color: isNightMode ? "#cbd5e1" : "#555" }}>

              {visionBody}

            </p>

          </motion.div>

        </div>

      </section>



      {/* CORE VALUES */}

      <section

        style={{

          textAlign: "center",

          padding: "60px 20px",

          maxWidth: "1100px",

          margin: "0 auto",

        }}

      >

        <span

          style={{

            display: 'inline-block',

            padding: '6px 12px',

            borderRadius: '9999px',

            background: '#A7E08D',

            border: '0',

            color: '#000',

            fontFamily: 'Arial, sans-serif',

            fontSize: '12px',

            fontStyle: 'normal',

            fontWeight: 400,

            lineHeight: '16px',

            textTransform: 'none',

            letterSpacing: '0',

            marginBottom: '14px'

          }}

        >

          Core Values

        </span>



        <h2 style={{ fontSize: "2rem", marginBottom: "10px", color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>

          What Drives Us

        </h2>

        <p style={{ color: isNightMode ? "#cbd5e1" : "#555", marginBottom: "40px" }}>

          Our values are the foundation of everything we do

        </p>



        <div className="about-core__grid">

          {coreValues.map((card, index) => (

            <motion.div

              key={index}

              style={{

                padding: "25px",

                background: isNightMode ? "#1e293b" : "white",

                borderRadius: "12px",

                boxShadow: isNightMode ? "0 3px 10px rgba(0,0,0,0.3)" : "0 3px 10px rgba(0,0,0,0.08)",

              }}

              initial={{ opacity: 0, y: 30 }}

              whileInView={{ opacity: 1, y: 0 }}

              viewport={{ once: true }}

              transition={{ duration: 0.5, delay: index * 0.1 }}

              whileHover={{ y: -8, scale: 1.03 }}

            >

              <div

                style={{

                  background: "#E6F4EA",

                  width: "50px",

                  height: "50px",

                  borderRadius: "50%",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  fontSize: "1.6rem",

                  margin: "0 auto 15px auto",

                }}

              >

                {card.icon}

              </div>

              <h4 style={{ marginBottom: "10px", color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>{card.title}</h4>

              <p style={{ color: isNightMode ? "#cbd5e1" : "#555", lineHeight: 1.6 }}>{card.desc}</p>

            </motion.div>

          ))}

        </div>

      </section>

      {/* MILESTONES & ACHIEVEMENTS */}

      <section

        className="about-timeline"

        style={{

          background: isNightMode ? "#0f172a" : "#F7F9F7",

          padding: "70px 20px",

          marginTop: "40px",

        }}

      >



        <div className="about-timeline__header" style={{ textAlign: "center", marginBottom: "40px" }}>

          <span

            style={{

              display: 'inline-block',

              padding: '6px 12px',

              borderRadius: '9999px',

              background: '#A7E08D',

              border: '0',

              color: '#000',

              fontFamily: 'Arial, sans-serif',

              fontSize: '12px',

              fontStyle: 'normal',

              fontWeight: 400,

              lineHeight: '16px',

              textTransform: 'none',

              letterSpacing: '0',

              marginBottom: '14px'

            }}

          >

            Our Journey

          </span>



          <h2 style={{ fontSize: "2rem", marginBottom: "10px", color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>

            Milestones & Achievements

          </h2>



          <p style={{ color: isNightMode ? "#cbd5e1" : "#555" }}>

            Key moments that shaped our growth and success

          </p>

        </div>



        {/* Timeline Container */}

        <div

          className="about-timeline__inner"

        >

          {timelineItems.map((item, index) => {

            return (

              <div key={index} className="about-timeline__item">

                <div className="about-timeline__rail">

                  <div className="about-timeline__dot" />

                  <div className="about-timeline__line" />

                </div>



                <div

                  className="about-timeline__card"

                  style={{

                    background: isNightMode ? "#1e293b" : "white",

                    borderRadius: "15px",

                    boxShadow: isNightMode ? "0px 6px 24px rgba(0,0,0,0.3)" : "0px 6px 24px rgba(0,0,0,0.08)",

                    position: "relative",

                    zIndex: 2,

                  }}

                >

                  <div

                    style={{

                      display: "flex",

                      alignItems: "center",

                      gap: "12px",

                      marginBottom: "8px",

                    }}

                  >

                    <span

                      style={{

                        display: "inline-block",

                        padding: "4px 10px",

                        borderRadius: "6px",

                        background: isNightMode ? "#E5F9D7" : "#E5E7EB",

                        color: "#111827",

                        fontSize: "0.8rem",

                        fontWeight: 500,

                      }}

                    >

                      {item.year}

                    </span>

                    <h3

                      style={{

                        margin: 0,

                        fontSize: "1rem",

                        fontWeight: 600,

                        color: isNightMode ? "#f1f5f9" : "#1a1a1a",

                      }}

                    >

                      {item.title}

                    </h3>

                  </div>



                  <p

                    style={{

                      margin: 0,

                      color: isNightMode ? "#cbd5e1" : "#555",

                      lineHeight: 1.6,

                    }}

                  >

                    {item.desc}

                  </p>

                </div>



                {/* Vertical line segment below the dot comes from about-timeline__line; last item hides it */}

              </div>

            );

          })}

        </div>

      </section>

      {/* TEAM SECTION */}

      <section

        className="about-team"

      >

        <span

          style={{

            display: 'inline-block',

            padding: '6px 12px',

            borderRadius: '9999px',

            background: '#A7E08D',

            border: '0',

            color: '#000',

            fontFamily: 'Arial, sans-serif',

            fontSize: '12px',

            fontStyle: 'normal',

            fontWeight: 400,

            lineHeight: '16px',

            textTransform: 'none',

            letterSpacing: '0',

            marginBottom: '14px'

          }}

        >

          Our Team

        </span>



        <h2 style={{ fontSize: "2rem", marginBottom: "10px", color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>

          Meet Our Leadership

        </h2>



        <p style={{ color: isNightMode ? "#cbd5e1" : "#555", marginBottom: "40px" }}>

          Experienced professionals dedicated to your success

        </p>



        {/* Team Cards */}

        <div

          className="about-team__grid"

          style={{

            maxWidth: "1100px",

            margin: "0 auto",

            alignItems: "stretch",

          }}

        >

          {teamMembers.map((member, index) => (

            <div

              key={index}

              className="about-team__card"

              style={{

                background: "transparent",

                borderRadius: "12px",

                boxShadow: "0 8px 22px rgba(12,20,16,0.06)",

                overflow: "hidden",

                textAlign: "center",

                transition: "transform 180ms ease, box-shadow 180ms ease",

              }}

              onMouseEnter={(e) => {

                e.currentTarget.style.transform = "translateY(-6px)";

                e.currentTarget.style.boxShadow = "0 18px 40px rgba(12,20,16,0.10)";

              }}

              onMouseLeave={(e) => {

                e.currentTarget.style.transform = "translateY(0)";

                e.currentTarget.style.boxShadow = "0 8px 22px rgba(12,20,16,0.06)";

              }}

            >

              {/* Image (rounded top corners only) */}

              <div style={{ overflow: "hidden", borderTopLeftRadius: "12px", borderTopRightRadius: "12px" }}>

                <img

                  src={member.img}

                  alt={member.name}

                  style={{

                    display: "block",

                    width: "100%",

                    height: "320px",          // tall image like the screenshot

                    objectFit: "cover",

                    objectPosition: "center top",

                  }}

                />

              </div>



              {/* White info panel */}

              <div

                style={{

                  background: isNightMode ? "#1e293b" : "#fff",

                  padding: "20px 18px",

                  borderBottomLeftRadius: "12px",

                  borderBottomRightRadius: "12px",

                }}

              >

                <h3 style={{ margin: "6px 0 8px", fontSize: "1.05rem", color: isNightMode ? "#f1f5f9" : "#111" }}>

                  {member.name}

                </h3>

                <p style={{ margin: 0, color: "#4A6640", fontSize: "0.9rem", fontWeight: 500 }}>

                  {member.role}

                </p>

              </div>

            </div>

          ))}

        </div>

      </section>





      {/* WHY CHOOSE US */}

      <section

        className="about-why"

        style={{

          background: "linear-gradient(135deg, #0A0F14, #1A252F)",

          color: "white",

          padding: "70px 20px",

          marginTop: "40px",

        }}

      >

        <div

          className="about-why__inner"

        >

          {/* Left: Reasons List */}

          <div style={{ flex: 1, minWidth: "280px" }}>

            <img src={`${process.env.PUBLIC_URL}/Group.svg`} alt="Tiwari Syndicate"

              style={{

                width: "70px",

                opacity: 0.9,

                marginBottom: "20px",

              }}

            />



            <h2 style={{ fontSize: "2rem", marginBottom: "10px" }}>

              {whyTitle}

            </h2>



            <p style={{ color: "#e5e7eb", marginBottom: "16px", maxWidth: "520px" }}>

              {whySubtitle}

            </p>



            <ul style={{ listStyle: "none", padding: 0, lineHeight: "1.8" }}>

              {whyReasons.map((item, i) => (

                <li

                  key={i}

                  style={{

                    marginBottom: "8px",

                    display: "flex",

                    alignItems: "center",

                    gap: "10px",

                  }}

                >

                  <div

                    style={{

                      width: "10px",

                      height: "10px",

                      background: "#8FDB6F",

                      borderRadius: "50%",

                    }}

                  ></div>

                  {item}

                </li>

              ))}

            </ul>

          </div>



          {/* Right: Stats Grid */}

          <div

            className="about-why__stats"

            style={{

              flex: 1,

              minWidth: "280px",

            }}

          >

            {whyStats.map((stat, idx) => {

              const isDark = stat.bg === "#1E252F";

              return (

                <div

                  key={idx}

                  style={{

                    background: stat.bg,

                    padding: "26px 20px",

                    borderRadius: "12px",

                    textAlign: "center",

                    color: isDark ? "#fff" : "#07120b",

                    minHeight: "150px", // keeps all cards same height

                    display: "flex",

                    flexDirection: "column",

                    alignItems: "center",

                    justifyContent: "center",

                    boxShadow: "0 8px 20px rgba(2,8,6,0.12)",

                  }}

                >

                  {/* ICON container (keeps icon style consistent) */}

                  <div

                    style={{

                      width: "56px",

                      height: "56px",

                      borderRadius: "10px",

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "center",

                      marginBottom: "14px",

                      background: isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",

                      border: isDark ? "2px solid rgba(255,255,255,0.06)" : "2px solid rgba(0,0,0,0.06)",

                      boxSizing: "border-box",

                    }}

                  >

                    <img

                      src={stat.icon}

                      alt={stat.label}

                      style={{

                        width: "34px",

                        height: "34px",

                        objectFit: "contain",

                        filter: isDark ? "brightness(0) invert(1)" : "none", // invert dark icons on dark bg if needed

                      }}

                    />

                  </div>



                  {/* VALUE */}

                  <h2 style={{ fontSize: "2rem", margin: "0 0 8px", lineHeight: 1 }}>

                    {stat.value}

                  </h2>



                  {/* LABEL */}

                  <p style={{ margin: 0, fontSize: "0.95rem", opacity: 0.95 }}>{stat.label}</p>

                </div>

              );

            })}

          </div>



        </div>

      </section>



      {/* READY TO WORK WITH US */}

      <section

        className="about-cta"

        style={{

          background: 'linear-gradient(135deg, #4A6640, #5D7F4E)',

          padding: "70px 20px",

          textAlign: "center",

          marginTop: "0px",

          color: "white",

          borderRadius: "0 0 15px 15px",

        }}

      >

        <div className="about-cta__inner">

          <h2 style={{ fontSize: "2rem", marginBottom: "10px" }}>

            {aboutCtaTitle}

          </h2>



          <p style={{ color: "#eaeaea", marginBottom: "30px", maxWidth: "600px", margin: "0 auto" }}>

            {aboutCtaSubtitle}

          </p>



          <div className="about-cta__buttons" style={{ marginTop: "30px", display: "flex", justifyContent: "center", gap: "15px" }}>

            <NavLink

              to={aboutCtaPrimaryHref}

              style={{

                color: "black",

                padding: "12px 24px",

                background: "white",

                borderRadius: "8px",

                border: "none",

                cursor: "pointer",

                fontWeight: "600",

                textDecoration: 'none',

              }}

            >

              {aboutCtaPrimaryLabel}

            </NavLink>



            <NavLink

              to={aboutCtaSecondaryHref}

              style={{

                padding: "12px 24px",

                background: "black",

                color: "white",

                borderRadius: "8px",

                border: "none",

                cursor: "pointer",

                fontWeight: "600",

                textDecoration: 'none',

              }}

            >

              {aboutCtaSecondaryLabel}

            </NavLink>

          </div>

        </div>

      </section>

      {/* Enquiry Modal */}
      {showEnquiryModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
          onClick={() => setShowEnquiryModal(false)}
        >
          <div
            style={{
              backgroundColor: isNightMode ? '#1e293b' : '#fff',
              borderRadius: '8px',
              padding: '24px',
              maxWidth: '400px',
              width: '90%',
              position: 'relative',
              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowEnquiryModal(false)}
              style={{
                position: 'absolute',
                top: '12px',
                right: '12px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: isNightMode ? '#cbd5e1' : '#666'
              }}
            >
              ×
            </button>

            {/* Modal Header */}
            <h2 style={{
              marginBottom: '20px',
              color: isNightMode ? '#f1f5f9' : '#1a1a1a',
              fontSize: '20px',
              fontWeight: '600',
              textAlign: 'center'
            }}>
              Contact Us
            </h2>

            {/* Status Message */}
            {enquiryStatus && (
              <div style={{
                padding: '10px 12px',
                borderRadius: '6px',
                marginBottom: '16px',
                fontSize: '14px',
                textAlign: 'center',
                fontWeight: '500',
                background: enquiryStatus.includes('successfully') ? '#d4edda' :
                  enquiryStatus.includes('Submitting') ? '#d1ecf1' : '#f8d7da',
                color: enquiryStatus.includes('successfully') ? '#155724' :
                  enquiryStatus.includes('Submitting') ? '#0c5460' : '#721c24',
                border: `1px solid ${enquiryStatus.includes('successfully') ? '#c3e6cb' :
                  enquiryStatus.includes('Submitting') ? '#bee5eb' : '#f5c6cb'
                  }`
              }}>
                {enquiryStatus}
              </div>
            )}

            {/* Form Fields */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  color: isNightMode ? '#cbd5e1' : '#333',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  Name *
                </label>
                <input
                  type="text"
                  value={enquiryData.name}
                  onChange={(e) => setEnquiryData({ ...enquiryData, name: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: `1px solid ${isNightMode ? '#475569' : '#ddd'}`,
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: isNightMode ? '#334155' : '#fff',
                    color: isNightMode ? '#f1f5f9' : '#333'
                  }}
                  placeholder="Enter your name"
                  required
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  color: isNightMode ? '#cbd5e1' : '#333',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  Email *
                </label>
                <input
                  type="email"
                  value={enquiryData.email}
                  onChange={(e) => setEnquiryData({ ...enquiryData, email: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: `1px solid ${isNightMode ? '#475569' : '#ddd'}`,
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: isNightMode ? '#334155' : '#fff',
                    color: isNightMode ? '#f1f5f9' : '#333'
                  }}
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  color: isNightMode ? '#cbd5e1' : '#333',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  Phone
                </label>
                <input
                  type="tel"
                  value={enquiryData.phone}
                  onChange={(e) => setEnquiryData({ ...enquiryData, phone: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: `1px solid ${isNightMode ? '#475569' : '#ddd'}`,
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: isNightMode ? '#334155' : '#fff',
                    color: isNightMode ? '#f1f5f9' : '#333'
                  }}
                  placeholder="Enter your phone number"
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  color: isNightMode ? '#cbd5e1' : '#333',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  Message *
                </label>
                <textarea
                  value={enquiryData.message}
                  onChange={(e) => setEnquiryData({ ...enquiryData, message: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: `1px solid ${isNightMode ? '#475569' : '#ddd'}`,
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: isNightMode ? '#334155' : '#fff',
                    color: isNightMode ? '#f1f5f9' : '#333',
                    minHeight: '100px',
                    resize: 'vertical'
                  }}
                  placeholder="Tell us about your requirements..."
                  required
                />
              </div>

              {/* Submit Button */}
              <button
                type="button"
                className="no-popup-submit"
                onClick={handleSubmitEnquiry}
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '6px',
                  border: 'none',
                  background: '#16a34a',
                  color: 'white',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#15803d'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#16a34a'}
              >
                Send Enquiry
              </button>
            </div>
          </div>
        </div>
      )}

    </main>

  );

}

